import {
    Datagrid,
    List,
    FunctionField,
    EditButton,
    ShowButton,
    TextInput,
    TopToolbar,
    CreateButton,
    DeleteWithConfirmButton
} from "react-admin";

import React from "react";
import { FieldGuesser } from '@api-platform/admin';

const ListActions = () => (
    <TopToolbar>
        <CreateButton/>
    </TopToolbar>
);
export const AudioList = () => (
    <List actions={<ListActions/>} >
        <Datagrid bulkActionButtons={false} rowClick={"edit"}>
            <FieldGuesser source="title" />
            <FieldGuesser source="srcLang" sortable={false} />
            <FieldGuesser source="createdAt" />
            <>
                <ShowButton/>
                <EditButton/>
                <DeleteWithConfirmButton/>
            </>
        </Datagrid>
    </List>
);
